// TODO rename to loadProfile
import {SystemStatusDataTable} from "../components/SystemStatusDataTable";
import BaseLayout from "../layout/BaseLayout";

export default function SystemStatusPage() {
    return (
            <BaseLayout child={<SystemStatusDataTable/>}/>
    )
}